<template>
	<div id="index">
		<div class="top">
			<div class="scrolltxt">{{scrolltxt}}</div>
			<div class="img_banner">
				<!-- <router-link to="/home/yyjj"><img src="@/assets/hosp.jpg" ></router-link>
				<router-link to="/home/activity"><img src="@/assets/youhui.jpg" ></router-link> -->
				<img src="@/assets/hosp.jpg" @click="goYyjj">
				<img src="@/assets/youhui.jpg" @click="goActivity">
			</div>
		</div>
		<div class="tab">
			<div class="tab_top">
				<div :class="['tab_top_item',index==current?'current_tab':'']" v-for="(item,index) in tablist" :key="item.title" @click="selectTab(item.title,index)">{{item.title}}</div>
			</div>
			<div class="tab_content">
				<div class="tab_content_item" @click="docInfo(item.id)" v-for="item in docList" :key="item.id">
					<div class="left_img"><img :src="'https://wx.xbjkyy.com/registerAdmin'+item.img" alt=""></div>
					<div class="right">
						<div class="name">
							<div class="left_name">{{item.name}}<span>{{item.zhicheng}}</span></div>
							<div class="icon">有号</div>
						</div>
						<div class="evaluate">
							<div><span>治疗满意度：{{item.manyidu}}%</span> | {{item.renshu}}人预约 </div>
							<div><span>余号{{item.yuhao}}</span></div>
						</div>
						<div class="department"><span>{{item.suoshu}}</span><span>{{item.keshi}}</span></div>
						<div class="info">
							擅长：{{item.shanchang}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	#index {
		background: #fff;
		.top {
			background: #F5F5F5;
			// padding-top: 120px;
			padding-top: 20px;

			.scrolltxt {
				width: 100%;
				height: 50px;
				font-size: 24px;
				line-height: 34px;
				padding: 15px 40px;
				overflow: hidden;

			}

			.img_banner {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 15px 40px;

				img {
					width: 306px;
					height: 221px;
					border-radius: 20px;
				}
			}

		}

		.tab {
			margin-top: 20px;

			.tab_top {
				width: 100%;
				display: flex;
				justify-content: space-around;
				align-items: center;
				padding: 0 40px;
				background: #F5F5F5;

				.tab_top_item {
					color: #000;
					font-size: 28px;
					// font-weight: bold;
					border-bottom: 4px solid #F5F5F5;
					padding: 15px 0;
				}

				.current_tab {
					color: #4A98F6;
					border-color: #4A98F6;
					font-weight: bold;
				}
			}

			.tab_content {
				width: 100%;
				background: #F5F5F5;
				margin-top: 20px;
				padding: 0 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				align-items: center;
				padding-bottom: 40px;

				.tab_content_item {
					width: 100%;
					padding: 40px 20px 20px;
					background: #fff;
					border-radius: 20px;
					margin-top: 40px;
					display: flex;
					justify-content: flex-start;
					align-items: flex-start;
					// margin: 15px 0;
					box-shadow: 0 10px 20px #DDDDDD;
					.left_img {
						width: 110px;
						height: 110px;
						border-radius: 50%;
						overflow: hidden;

						img {
							width: 100%;
						}
					}

					.right {
						display: flex;
						flex-direction: column;
						justify-content: flex-start;
						align-items: flex-start;
						margin-left: 40px;
						width: 100%;

						.name {
							width: 100%;
							display: flex;
							justify-content: space-between;
							align-items: center;

							.left_name {
								font-size: 30px;
								color: #000;
								font-weight: bold;

								span {
									font-size: 25px;
									margin-left: 15px;
								}
							}

							.icon {
								font-size: 20px;
								color: #fff;
								background: #4A98F6;
								border-radius: 25px;
								padding: 5px 15px;

							}
						}

						.evaluate {
							width: 100%;
							margin-top: 10px;
							display: flex;
							justify-content: space-between;
							align-items: center;
							font-size: 25px;
							color: #000;

							span {
								color: red;
							}

						}

						.department {
							margin-top: 10px;
							font-size: 25px;
							color: #000;

							span {
								margin-right: 20px;
							}
						}

						.info {
							margin-top: 10px;
							font-size: 25px;
							line-height: 40px;
							color: #000;
						}
					}
				}
			}
		}

	}
</style>

<script>
	import {
		Toast
	} from 'mint-ui';
	export default {
		name: "Index",
		data() {
			return {
				scrolltxt: '即日起在咨询页面或者挂号页面留电患者，可参与存100报销1000,存200报销2000，存300报销3000，存400报销4000，存500报销5000的医疗费用抵扣，此次存下来的钱将会用于贫困家庭的资助，活动长期有效，爱无到期时间，希望大家踊跃参与，不仅帮助了贫困家庭还能享受10倍资金的医疗费用补助，让我们一起将爱传递下去吧!!!',
				docList: [],
				tablist: [{
						title: '院内专家'
					},
					{
						title: '会诊专家'
					},
					{
						title: '全部专家'
					}
				],
				current:2,
				type: "all"
			};
		},
		created() {
			// 获取滚动的文字
			this.getScrollText();
			// 获取全部医生
			let params = {
				params: {
					type: 'all'
				}
			};
			this.$http.get(this.$api.GHlist, params).then(res => {
				// console.log('获取全部医生成功');
				// console.log(res);
				if (res.data.code == 0) {
					this.docList = res.data.data;
				} else {
					Toast({
						message: res.data.msg,
						position: 'center',
						duration: 2000
					});
				}
			}).catch(error => {
				// console.log('获取全部医生失败');
				// console.log(error);
				Toast({
					message: error.data.msg || error.data.message,
					position: 'center',
				});
			});
		},
		mounted() {
			setInterval(this.run, 200);
		},
		methods: {
			goYyjj(){
				this.$router.push({
					name: 'Yyjj'
				});
			},
			goActivity(){
				this.$router.push({
					name: 'Activity'
				});
			},
			run() {
				var new_str = this.scrolltxt.substr(2, this.scrolltxt.length);
				var sub_str = this.scrolltxt.substr(0, 2);
				this.scrolltxt = new_str + sub_str;
			},
			docInfo(id) {
				// 医师详情
				this.$router.push({
					name: 'Docinfo',
					query: {
						id: id
					}
				})
			},
			getScrollText(){
				let params = {
					params: {
						
					}
				};
				this.$http.get(this.$api.GHscrolltxt, params).then(res => {
					// console.log('获取医生成功');
					// console.log(res);
					if (res.data.code == 0) {
						this.scrolltxt = res.data.data[0].text;
					} else {
						Toast({
							message: res.data.msg,
							position: 'center',
							duration: 2000
						});
					}
				}).catch(error => {
					// console.log('获取医生失败');
					// console.log(error);
					Toast({
						message: error.data.msg || error.data.message,
						position: 'center',
					});
				});
			},
			selectTab(yiyuan,index){
				// tab样式切换
				this.current = index;
				if(yiyuan=="院内专家"){
					this.type ="benyuan";
				}else if(yiyuan=="会诊专家"){
					this.type ="huizhen";
				}else{
					this.type ="all";
				}
				// console.log(yiyuan);
				// 下面数据更新
				let params = {
					params: {
						type: this.type
					}
				};
				this.$http.get(this.$api.GHlist, params).then(res => {
					// console.log('获取医生成功');
					// console.log(res);
					if (res.data.code == 0) {
						this.docList = res.data.data;
					} else {
						Toast({
							message: res.data.msg,
							position: 'center',
							duration: 2000
						});
					}
				}).catch(error => {
					// console.log('获取医生失败');
					// console.log(error);
					Toast({
						message: error.data.msg || error.data.message,
						position: 'center',
					});
				});
				
			}
		}
	};
</script>
